function isDecimal(num) {
  return num % 1 !== 0;
}

export const chargerDataFormatted = (
  data,
  excludeKeys = ["user_id", "site", "other_costs_description"]
) => {
  return data.map((result) => {
    const convertedItem = {};
    for (const key in result) {
      if (excludeKeys.includes(key)) {
        convertedItem[key] = result[key];
      } else {
        if (key.toLowerCase() === "year") {
          if (result[key] === "" || result[key] === null) {
            convertedItem[key] = new Date().getFullYear();
          } else if (
            result[key] > 1000 &&
            result[key] < 5000 &&
            !isDecimal(result[key])
          ) {
            convertedItem[key] = Math.trunc(Math.abs(Number(result[key])));
          } else {
            throw Error("Invalid year: year needs to be between 1000 - 5000");
          }
        } else {
          if (result[key] < 0 || isDecimal(result[key])) {
            throw Error(
              `Invalid ${key}: ${result[key]} is not a valid number.`
            );
          } else {
            convertedItem[key] = Number(result[key]);
          }
        }
      }
    }
    return convertedItem;
  });
};
